import React from 'react';

import { useTranslation } from 'react-i18next';

import { ReactComponent as OpenSeaIcon } from '@pkg/assets/icons/v2/opensea.svg';
import { ButtonDeprecated, MetaMaskStatus } from '@pkg/components';
import { useAppDispatch, useAppSelector, useMetaMask } from '@pkg/hooks';

import { setNftPanelOpen } from '@app/store/actions/nft';

import { Typography } from '../../../DesignSystem';
import '../NftSidePanel.scss';

interface NftMintCompleteProps {
    videoUrl: string;
}

export const NftMintComplete = ({ videoUrl }: NftMintCompleteProps) => {
    const { t } = useTranslation(['nft', 'dashboard']);
    const { isMetaMaskConnected } = useMetaMask();
    const { openSeaUrl } = useAppSelector((state) => state.nft);
    const dispatch = useAppDispatch();

    const onClickOpenSea = () => {
        window.open(openSeaUrl || '', '_blank');
        dispatch(setNftPanelOpen(false));
    };

    return (
        <div className="yat-nft-sidebar__step yat-nft-sidebar__complete">
            <div className="yat-nft-sidebar__flex-item">
                <Typography type="headline" size={40} classes={['yat-nft-sidebar__title']}>
                    {t('mint_yat_complete_title')}
                </Typography>
                <Typography type="paragraph" size={16} classes={['yat-nft-sidebar__text']}>
                    <span>{t('mint_yat_complete_text')}</span>
                </Typography>

                <div className="yat-nft-sidebar__visualized_yat">
                    <video autoPlay muted webkit-playsinline="true" playsInline loop>
                        <source src={videoUrl} type="video/mp4" />
                    </video>
                </div>

                {openSeaUrl && (
                    <ButtonDeprecated
                        classes={['yat-nft-sidebar__opensea']}
                        color="tertiary"
                        icon={<OpenSeaIcon />}
                        onClick={onClickOpenSea}
                        size="large"
                    >
                        {t('dashboard:view_on_opensea')}
                    </ButtonDeprecated>
                )}
            </div>

            {isMetaMaskConnected && <MetaMaskStatus classes={['yat-nft-sidebar__metamask-status']} />}
        </div>
    );
};
